import { useEffect } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import {
  ClaimNonprofitBanner,
  EasilyShare,
  ShareStories,
  ContentText,
  ShareStoriesImage,
  EasilyShareSupporters,
  EasilyShareMain,
  EasilyShareVideo,
  VideoSection,
  VideoWrapper,
  GnpStatistics,
  GnpTitle,
  GnpStatisticsList,
  GnpStatisticsItem,
  MoreDonors,
  MoreDonorsLeft,
  MoreDonorsRight,
  TextCol,
  InviteReviews,
  SocialMedia,
  InviteTitle,
  InviteText,
  EasilyReachSection,
  AudienceToday,
  AudienceTitle,
  BoostDonor,
  ClientContent,
  DonarTitle,
  DonarText,
  ClientImageCol,
  BillQut,
  BillText,
  BottomTitle,
  Volunteers,
  VolunteersImage,
  VolTitle,
  VolunteersNumber,
  NonprofitsList,
  NonprofitsItem,
  GreatNonprofits,
  TestimonialsSection,
  TestimonialBoxGroup,
  ClientMainBox,
  ClientBox,
  ClientReview,
  ClientDesignation,
  Designation,
  TestimonialTitle,
  FreeProfile,
  CollectDonations,
  GreatNonprofitWrapper,
  GreatNonprofitsLeft,
  GreatNonprofitsRight,
  GreatTitle,
  GreatText,
  GreatNonprofitsBadge,
  BadgeTitle,
  BadgeLeft,
  BadgeRight,
  BadgeSmall,
  BadgeText,
  BadgeWrapper,
  FreeProfileText,
  NonprofitsStrong,
  NonprofitsSpan,
  RecognitionToday,
  RecognitionTitle,
  TitleEasily,
} from './getStartedStyle';
import PeninsulaCollege from "../../../assests/images/peninsulacollege.webp";
import SocialMediaRequests from '../../../components/common/SocialMediaRequests/SocialMediaRequests';
import ReviewSerch from '../../../components/common/reviewSerchBox';
import ClientImage from "../../../assests/images/client.webp";
import WhiteQuoteIcon from '../../../assests/images/whitequoteicon.svg';
import VolunteersIma from '../../../assests/images/pexels-cottonbro.webp';
import Client from '../../../assests/images/client1.webp';
import CollectImage from '../../../assests/images/pexels-karolina.webp';
import BadgeOneImage from '../../../assests/images/badgeone.webp';
import BadgeTwoImage from '../../../assests/images/badgetwo.webp';
import RecognitionIcon from '../../../assests/images/subtractionicon.svg';
import ArrowIcon from '../../../assests/images/bluearrow.svg'
import {
  Title,
  WriteReviewSection,
  ReviewText,
  ReviewSearch,
  ReviewSerchBox,
  ReviewRightSection,
  LeftQuote,
  RightQuote,
  RightBanner,
} from '../../../components/common/commonSubBanner/commonSubBannerStyle';
import GetBanner from "../../../assests/images/get-banner.webp";
import QuoteIcon from "../../../assests/images/quoteicon.svg";
import { useDispatch, useSelector } from "react-redux";
import { endorsementsHandler } from "../../../redux/slices/endorsements/endorsements-slice";
import { MESSAGE } from "../../../utils/message";
import MetaComponent from "../../../components/common/metaComponent";
import SearchBox from "../../../components/common/searchBox/searchBox";

const GetStarted = () => {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const endorsementsList = useSelector((state: any) => state?.endorsements?.data);
  useEffect(() => {
    dispatch(endorsementsHandler())
  }, [])
  return (
    <>
      <MetaComponent
        keywords=""
        description="Claim your nonprofit and collect reviews from your supporters!"
        ogTitle="Nonprofits, Get Started | GreatNonprofits"
        ogDescription="Claim your nonprofit and collect reviews from your supporters!"
        ogUrl="https://www.about.greatnonprofits.org/get-started"
        ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
      />
      <>

        <ClaimNonprofitBanner>
          <WriteReviewSection className="get-started-banner">
            <Container className="cont-w">
              <Row>
                <Col lg={6} sm={12} md={12}>
                  <Title className="get-title">Get Visibility and Recognition</Title>
                  <ReviewText>Show the impact of your Nonprofit. Enable your clients, volunteers and donors to share their experience and write a review about your organization. </ReviewText>
                  <ReviewSearch>
                    <ReviewSerchBox>
                      <SearchBox />
                      {/* <Form className="search-header" onSubmit={formik.handleSubmit}>
                        <SearchInputBox>
                          <InputGroup>
                            <InputGroupIcon>
                              <Image src={Search_icon} width="20px" height="20px" className="search-group-icon" />
                            </InputGroupIcon>
                            <FormControl type="text"
                              placeholder="Org,City & State"
                              id="location"
                              maxLength={30}
                              name="location"
                              value={formik.values.location}
                              onChange={formik.handleChange} />
                            {formik.touched.location && formik.errors.location && (
                              <div className="error">
                                <p>{formik.errors.location}</p>
                              </div>
                            )}
                          </InputGroup>
                          <InputGroup className="zipcode">
                            <FormControl type="number"
                              onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()}
                              placeholder="Zip Code"
                              maxLength={10}
                              name="zipcode"
                              value={formik.values.zipcode}
                              onChange={formik.handleChange} />
                            {formik.touched.zipcode && formik.errors.zipcode && (
                              <div className="error">
                                <p>{formik.errors.zipcode}</p>
                              </div>
                            )}
                          </InputGroup>
                        </SearchInputBox>
                        <Button variant="outline-success" type="submit">Search</Button>
                      </Form> */}
                    </ReviewSerchBox>
                  </ReviewSearch>
                </Col>
                <Col lg={6} sm={12} md={12}>
                  <RightBanner className="left_banner">
                    <ReviewRightSection>
                      <LeftQuote className="quote_col"><span><Image src={QuoteIcon} alt="QuoteIcon" /></span> I've worked in nonprofits for over 20 years, and having this tool now is a first for me. I'm really grateful for it.</LeftQuote>
                      <Image src={GetBanner} alt="ReviewImage" />
                      <RightQuote className="quote_col"><span><Image src={QuoteIcon} alt="QuoteIcon" /></span> I've worked in nonprofits for over 20 years, and having this tool now is a first for me. I'm really grateful for it.</RightQuote>
                    </ReviewRightSection>
                  </RightBanner>
                </Col>
              </Row>
            </Container>
          </WriteReviewSection>
        </ClaimNonprofitBanner>

        <EasilyShareMain>
          <EasilyShare>
            <Container className="cont-w">
              <EasilyShareSupporters>
                <ShareStories>
                  <TitleEasily>Easily Share the Stories from Your Supporters</TitleEasily>
                  <ContentText>Show the impact of your nonprofit. Enable your clients, volunteers, and donors to share their experience and stories about your organization.</ContentText>
                </ShareStories>
                <ShareStoriesImage>
                  <Image src={PeninsulaCollege} alt='PeninsulaCollege' />
                </ShareStoriesImage>
              </EasilyShareSupporters>
            </Container>
          </EasilyShare>

          <EasilyShareVideo>
            <Container className="cont-w">
              <VideoWrapper>
                <VideoSection>
                  <video
                    className='video'
                    controls
                    poster="../../assests/images/peninsulacollege.webp">
                    <source src="../../assests/images/video.mp4" />
                    <track kind="captions" />
                  </video>
                </VideoSection>
                <GnpStatistics>
                  <ContentText>With limited time and resources, how do you share your stories of impact in a non-biased, and credible fashion&#63; GreatNonprofits offers a free and easy-to-use platform to share and collect reviews and stories about the community you serve&#8208;so donors and volunteers know about you and your good work&#8208;</ContentText>
                  <GnpTitle>GNP Statistics</GnpTitle>
                  <GnpStatisticsList>
                    <GnpStatisticsItem>
                      <strong>80% of donors </strong><span>say reviews influence their giving!</span>
                    </GnpStatisticsItem>
                    <GnpStatisticsItem>
                      <strong>90% of donors</strong><span> say reviews help them better understand a nonprofit's work!</span>
                    </GnpStatisticsItem>
                    <GnpStatisticsItem>
                      <span>More than <strong>3 million </strong> people visit GreatNonprofits a year</span>
                    </GnpStatisticsItem>
                    <GnpStatisticsItem>
                      <span>  GreatNonprofits has<strong> more than 200,000 reviews</strong>   and growing!</span>
                    </GnpStatisticsItem>
                  </GnpStatisticsList>
                </GnpStatistics>
              </VideoWrapper>
            </Container>
          </EasilyShareVideo>
          <MoreDonors>
            <MoreDonorsLeft>
              <TitleEasily>Reach More Donors & Volunteers</TitleEasily>
              <TextCol>Reach More Donors and Volunteers Gain Exposure with Review Syndication</TextCol>
              <ContentText>Show the impact of your nonprofit. Enable your clients, volunteers, and donors to share their experience and stories about your organization.</ContentText>
            </MoreDonorsLeft>
            <MoreDonorsRight>
              <Image src={PeninsulaCollege} alt='PeninsulaCollege' />
            </MoreDonorsRight>
          </MoreDonors>
        </EasilyShareMain>

        <InviteReviews>
          <Container className="cont-w">
            <InviteTitle>{MESSAGE.inviteReviewsClientVolunteersDonors}</InviteTitle>
            <InviteText>Copy the following templates and paste them on your email and social media requests and posts!</InviteText>
            <SocialMedia>
              <SocialMediaRequests />
              <SocialMediaRequests />
              <SocialMediaRequests />
            </SocialMedia>
          </Container>
        </InviteReviews>

        <EasilyReachSection>
          <Container className="cont-w">
            <AudienceToday>
              <AudienceTitle>{MESSAGE.easilyLargerAudienceToday}</AudienceTitle>
              <ReviewSerch />
            </AudienceToday>
            <BoostDonor>
              <ClientContent>
                <DonarTitle>{MESSAGE.boostDonorTrustAndConfidence}</DonarTitle>
                <DonarText>85% of donors consider reading reviews helpful when deciding to make a donation. </DonarText>
                <DonarText>After the Better Business Bureau, the GreatNonprofits badge
                  is the most trusted rating seal for donors! <Link to='/'>Learn more <Image src={ArrowIcon} /></Link>  </DonarText>
              </ClientContent>

              <ClientImageCol>
                <Image src={ClientImage} alt='ClientImage' />
              </ClientImageCol>

              <BillQut>
                <BillText>GreatNonprofits focuses on helping people make great giving decisions through socially sourced feedback and reviews."</BillText>
                <BottomTitle>
                  <strong>Bill Gates, <span>Microsoft</span> </strong>
                  <Image src={WhiteQuoteIcon} alt='WhiteQuoteIcon' />
                </BottomTitle>
              </BillQut>

            </BoostDonor>
            <GreatNonprofits>
              <VolTitle>Funders and volunteers use Great Nonprofits every day to research nonprofits.</VolTitle>
              <Volunteers>
                <VolunteersImage><Image src={VolunteersIma} alt='VolunteersIma' /> </VolunteersImage>
                <VolunteersNumber>
                  <NonprofitsList>
                    <NonprofitsItem>
                      <NonprofitsStrong>85%</NonprofitsStrong>
                      <NonprofitsSpan>of donors say that reviews influence their giving.</NonprofitsSpan>
                    </NonprofitsItem>
                    <NonprofitsItem>
                      <NonprofitsStrong>90%</NonprofitsStrong>
                      <NonprofitsSpan>of donors say reviews help them understand the nonprofits' mission</NonprofitsSpan>
                    </NonprofitsItem>
                    <NonprofitsItem>
                      <NonprofitsStrong>81%</NonprofitsStrong>
                      <NonprofitsSpan>of users say reviews have helped them decide where to volunteer</NonprofitsSpan>
                    </NonprofitsItem>
                  </NonprofitsList>
                </VolunteersNumber>
              </Volunteers>
            </GreatNonprofits>
          </Container>
        </EasilyReachSection>

        <TestimonialsSection>
          <Container className="cont-w">
            <TestimonialTitle>{MESSAGE.testimonials}</TestimonialTitle>
            <ClientMainBox>
              <Row>
                <Col md={12}>
                  <TestimonialBoxGroup>
                    {endorsementsList?.data?.map((endorsements: any, index: number) => (
                      <ClientBox key={index + 1}>
                        <ClientReview>{endorsements?.quote}</ClientReview>
                        <ClientDesignation>
                          <Image src={Client} alt='Client' />
                          <Designation>
                            <strong>{endorsements?.quoteBy}</strong>
                            <a
                              href="#!"
                              onClick={() => navigate("/org/1")}>
                              <span>{endorsements?.from}</span>
                            </a>
                          </Designation>
                        </ClientDesignation>
                      </ClientBox>
                    ))}
                  </TestimonialBoxGroup>
                </Col>
              </Row>
            </ClientMainBox>
          </Container>
        </TestimonialsSection>
        <FreeProfile>
          <Container className="cont-w">
            <FreeProfileText>Your free profile page is a great destination to host information about your nonprofit.</FreeProfileText>
            <FreeProfileText> GreatNonprofits already has more than 1.3 million projects and profiles in its database&#8210; chances are that you are already listed! </FreeProfileText>
            <FreeProfileText> Once you&#8217;ve claimed your profile, you&#8217;ll want to update your profile with your mission, photos of your team, videos, social media links, donation links, and more.</FreeProfileText>
          </Container>
        </FreeProfile>

        <CollectDonations>

          <Container className="cont-w">
            <GreatNonprofitWrapper>
              <GreatNonprofitsLeft>
                <GreatTitle>{MESSAGE.collectDonationsGreatNonprofits}</GreatTitle>
                <GreatText>Did you know you can collect donations through GreatNonprofits? If you&#8217;ve already entered your own donation platform, no worries! But if you don&#8217;t have a donation platform, we&#8217;ve partnered with PayPal Giving Fund. Donations are made to PayPal Giving Fund, an IRS-registered 501(c)(3) public charity, and is subject to PayPal Giving Fund&#8217;s policies and terms of service for donors. PayPal Giving Fund receives the donation, which is typically tax deductible, net of payment processing fees of 1.99% + $0.49. PayPal Giving Fund typically grants funds to recommended charities within 15-45 days, or 90 days, if the charity isn't enrolled with PayPal Giving Fund.</GreatText>
              </GreatNonprofitsLeft>
              <GreatNonprofitsRight>
                <Image src={CollectImage} alt='CollectImage' />
              </GreatNonprofitsRight>
            </GreatNonprofitWrapper>
          </Container>
        </CollectDonations>

        <GreatNonprofitsBadge>
          <Container className="cont-w">
            <BadgeWrapper>
              <BadgeLeft>
                <BadgeTitle>{MESSAGE.theGreatNonprofitsBadge}</BadgeTitle>
                <BadgeSmall>The mark of a nonprofit committed to transparency.</BadgeSmall>
                <BadgeText>The GreatNonprofits Badge gives instant visual feedback to visitors allowing them to see at a glance that your business is committed to transparency. With one click, visitors can easily read and submit reviews about your
                  organization, as well as view your detailed profile that includes valuable information. </BadgeText>
                <BadgeText>
                  Putting the GreatNonprofits Badge on your site is just a matter of cutting and pasting-Simply go to your nonprofit profile page and
                  click on the <strong>'Get link or badge'</strong> on the left hand column.</BadgeText>
              </BadgeLeft>
              <BadgeRight>
                <Image src={BadgeOneImage} alt='Badge One Image' />
                <Image src={BadgeTwoImage} alt='Badge Two Image' />
              </BadgeRight>
            </BadgeWrapper>
          </Container>
        </GreatNonprofitsBadge>

        <RecognitionToday>
          <Container className="cont-w">
            <RecognitionTitle><Image src={RecognitionIcon} alt='RecognitionIcon' />{MESSAGE.getRecognitionToday}</RecognitionTitle>
            <ReviewSerch />
          </Container>
        </RecognitionToday>
      </></>)
};
export default GetStarted;